export enum UrlParameters {
  Year = 'year',
  Make = 'make',
  Model = 'model',
  Badge = 'badge',
  Price = 'price',
  Seat = 'seat',
  Door = 'door',
  BodyType = 'bodytype',
  Lifestyle = 'lifestyle',
  FuelType = 'fueltype',
  TowingCapacity = 'towingcapacity',
  EmissionsRating = 'emissionsrating',
  DrivingRange = 'drivingrange',
  TransmissionType = 'transmissiontype',
  DriveType = 'drivetype',
  EngineType = 'enginetype',
  Cylinder = 'cylinder',
  EngineCapacity = 'enginecapacity',
  FuelScore = 'fuelscore',
  SafetyRating = 'safetyrating',
  Feature = 'feature',
};